import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ProductsPage from '../pages/ProductsPage';
import SolutionsPage from '../pages/SolutionsPage';
import IndustriesPage from '../pages/IndustriesPage';
import ResourcesPage from '../pages/ResourcesPage';
import CompanyPage from '../pages/CompanyPage';
import ContactPage from '../pages/ContactPage/ContactPage';
import BookDemoPage from '../pages/BookDemoPage/BookDemoPage'; // Import the new BookDemoPage
import App from '../App';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<App />}>
        <Route index element={<HomePage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="solutions" element={<SolutionsPage />} />
        <Route path="industries" element={<IndustriesPage />} />
        <Route path="resources" element={<ResourcesPage />} />
        <Route path="company" element={<CompanyPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="book-demo" element={<BookDemoPage />} /> {/* Add the new book-demo route */}
      </Route>
    </Routes>
  );
};

export default AppRouter;
